import { scrollToSection } from "../../lib/scrollToSection"
export const BtnTogether1 = () => (
    <a onClick={(e) => scrollToSection(e)} href="#contact">Vamos construir juntos!</a>
)